module.exports = __webpack_public_path__ + "media/wonderful-world.e657d239.mp3";